app.filter('toTrusted', ['$sce', function ($sce) {
    return function (value) {
        return $sce.trustAsHtml(value);
    };
}]);

app.filter('toTrustedMore', ['$sce', function ($sce) {
    return function (value) { 
        // var values = value.split('</P>');
        // if ( values.length > 2 ) {
        //     var short = values[0] + values[1];
        //     for (var i = 2; i < values.length; i++) {
        //         if ( values[i] != undefined ){
        //             var more = more + values[i]
        //         }
        //     }
        //     return '<div class="short">' + $sce.trustAsHtml(short) + '  <span class="seemorelink"></span></div><div class="more">' + $sce.trustAsHtml(more) + '</div>';
        // }else{
        // }
        return '<div class="inner">' + $sce.trustAsHtml(value) + '</div>';   
    };
}]);

app.filter('currency', ['$sce', function ($sce) {
    return function (amount, symbol) {
        let culture = gym[0].Culture || 'en-US';
        let currency = infoData.CurrencyCode || 'USD';
        if (customCurrency) currency = customCurrency;

        let formatted = '';
        if (typeof amount === 'number' && !isNaN(amount)) {
            let now = new Date();
            let euro = parseFloat(amount / 1.95583).toFixed(2);
            let bgn = new Intl.NumberFormat('bg-BG', {
                style: 'currency',
                currency: 'BGN',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(amount);
            let euroFormatted = new Intl.NumberFormat('de-DE', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(euro);

            // Date logic
            let date2026 = new Date('2026-01-01');
            let date2027 = new Date('2027-01-01');

            if (culture === 'bg-BG') {
                if (now < date2026) {
                    // Until 01.01.2026: show BGN (EUR)
                    formatted = `${bgn} <span style="font-size:0.9em;opacity:0.7;">(${euroFormatted})</span>`;
                } else if (now >= date2026 && now < date2027) {
                    // From 01.01.2026 to 01.01.2027: show EUR (BGN)
                    formatted = `${euroFormatted} <span style="font-size:0.9em;opacity:0.7;">(${bgn})</span>`;
                } else {
                    // After 01.01.2027: show only EUR
                    formatted = `${euroFormatted}`;
                }
            } else {
                // Other currencies
                formatted = new Intl.NumberFormat(culture, {
                    style: 'currency',
                    currency: currency,
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }).format(amount);
            }
        }

        return $sce.trustAsHtml(formatted);
    }
}])